<template>
  <div>
    <SnackbarComponent v-model="snackbar.show" :message="snackbar.message" :color="snackbar.color" />

    <!-- Wider dialog -->
    <v-dialog v-model="dialog" max-width="900px" persistent>
      <v-card>
        <v-tabs v-model="activeTab" bg-color="white">
          <v-tab :value="0">Edit Organization</v-tab>
          <v-tab :value="1">Organization Settings</v-tab>
        </v-tabs>
        <!-- <v-card-title class="text-h5 pa-4"> Edit Organization </v-card-title> -->

        <v-divider />
        <v-window v-model="activeTab">
          <!-- ================= EDIT FACILITY TAB ================= -->
          <v-window-item :value="0">
            <!-- Scroll only inside form -->
            <v-card-text class="pa-6" style="max-height: 65vh; overflow-y: auto">
              <v-form ref="form" v-model="valid">
                <!-- ================= Organization Information ================= -->
                <div class="mb-6">
                  <h3 class="text-h6 mb-3 primary--text">
                    Organization Information
                  </h3>

                  <v-row dense>
                    <v-col cols="6">
                      <v-text-field v-model="formData.organizationName" label="Organization Name*" variant="outlined"
                        density="compact" :rules="[(v) => !!v || 'Organization Name is required']" />
                    </v-col>

                    <v-col cols="6">
                      <v-text-field v-model="formData.complianceLicense" label="Additional Information"
                        variant="outlined" density="compact" />
                    </v-col>

                    <v-col cols="12">
                      <v-textarea v-model="formData.registeredAddress" label="Registered Address*" variant="outlined"
                        density="compact" rows="1" auto-grow
                        :rules="[(v) => !!v || 'Registered Address is required']" />
                    </v-col>

                    <v-col cols="12">
                      <v-textarea v-model="formData.organization_secondary_address" label="Secondary Address*"
                        variant="outlined" density="compact" rows="1" auto-grow readonly />
                    </v-col>

                    <v-col cols="6">
                      <v-autocomplete v-model="formData.category_creation_level" label="Category Creation Required*"
                        variant="outlined" density="compact" :items="defaultItems" item-title="title" item-value="value"
                        :rules="[(v) => !!v || 'Category Creation is required']" />
                    </v-col>

                    <v-col cols="6">
                      <v-autocomplete v-model="formData.template_creation_level" label="Template Creation Required*"
                        variant="outlined" density="compact" :items="defaultItems" item-title="title" item-value="value"
                        :rules="[(v) => !!v || 'Template Creation is required']" />
                    </v-col>
                    <v-col cols="6">
                      <v-checkbox v-model="formData.should_consent_be_visible" label="Make Consent Visible"
                        color="primary" hide-details
                        @keydown.enter.prevent="handleCheckboxEnter('should_consent_be_visible')"></v-checkbox>
                    </v-col>
                  </v-row>
                </div>

                <!-- ================= License Configuration ================= -->
                <div class="mb-6">
                  <h3 class="text-h6 mb-3 primary--text">License Configuration</h3>

                  <!-- Plan selector ONLY if original was TRIAL -->
                  <v-radio-group v-if="formData.originalLicenseType === 'TRIAL'" v-model="formData.licenseType" inline
                    class="mb-4" label="Plan">
                    <v-radio label="PAID" value="ANNUAL" />
                    <v-radio label="TRIAL" value="TRIAL" />
                  </v-radio-group>
                  <v-radio-group v-if="formData.licenseType === 'ANNUAL'" v-model="formData.annualSubType" inline
                    class="mb-3" label="Annual Plan Type">
                    <!-- BOTH always selectable -->
                    <v-radio label="Both (Annual + MRR)" value="BOTH" />

                    <!-- ANNUAL ONLY -->
                    <v-radio label="Annual Only" value="ANNUAL" :disabled="formData.originalLicenseType === 'ANNUAL' &&
                      (formData.originalSubPlan === 'BOTH' ||
                        formData.originalSubPlan === 'MRR')
                      " />

                    <!-- MRR ONLY -->
                    <v-radio label="MRR Only" value="MRR" :disabled="formData.originalLicenseType === 'ANNUAL' &&
                      (formData.originalSubPlan === 'BOTH' ||
                        formData.originalSubPlan === 'ANNUAL')
                      " />
                  </v-radio-group>

                  <!-- ================= ANNUAL ================= -->
                  <div v-if="formData.licenseType === 'ANNUAL'">
                    <v-row dense>
                      <!-- Per User Annual Plan -->
                      <v-col cols="6" v-if="['BOTH', 'ANNUAL'].includes(formData.annualSubType)">
                        <v-text-field v-model="formData.annualAmount" label="Price Per user Annual" variant="outlined"
                          density="compact" type="text" inputmode="numeric" maxlength="10" @keydown="allowOnlyNumbers"
                          @paste="preventNonNumericPaste" @input="sanitizeNumber('annualAmount')" :readonly="formData.licenseType === 'ANNUAL' &&
                            formData.licenseType == formData.originalLicenseType &&
                            formData.annualSubType == formData.originalSubPlan
                            " :rules="[(v) => !!v || 'Price Per user Annual is required']" />
                      </v-col>

                      <!-- Current users (ONLY if original ANNUAL) -->
                      <v-col cols="6" v-if="['BOTH', 'ANNUAL'].includes(formData.annualSubType)">
                        <v-text-field v-model="formData.noOfUsers" label="License User" variant="outlined"
                          density="compact" :readonly="formData.licenseType === 'ANNUAL' &&
                            formData.licenseType == formData.originalLicenseType &&
                            formData.annualSubType == formData.originalSubPlan
                            " type="text" inputmode="numeric" maxlength="6" @keydown="allowOnlyNumbers"
                          @paste="preventNonNumericPaste" @input="sanitizeNumber('noOfUsers')"
                          :rules="[(v) => !!v || 'License User is required']" />
                      </v-col>

                      <!-- User Adjustment -->
                      <v-col cols="6" v-if="
                        formData.originalLicenseType === 'ANNUAL' &&
                        ['BOTH', 'ANNUAL'].includes(formData.annualSubType)
                      ">
                        <!-- <v-radio-group
                      v-model="formData.userChangeType"
                      inline
                      label="License User Adjustment"
                    >
                      <v-radio label="Add" value="ADD_SEATS" />
                      <v-radio label="Remove" value="REDUCE_SEATS" />
                    </v-radio-group> -->
                        <v-alert type="info" variant="tonal" density="compact" class="mb-3">
                          You can only add additional license users.
                        </v-alert>
                      </v-col>

                      <!-- User Delta -->
                      <v-col cols="6" v-if="
                        formData.originalLicenseType === 'ANNUAL' &&
                        ['BOTH', 'ANNUAL'].includes(formData.annualSubType)
                      ">
                        <v-text-field v-model="formData.userDelta" label="No of License Users to Add for Annual"
                          variant="outlined" density="compact" type="text" inputmode="numeric" maxlength="6"
                          @keydown="allowOnlyNumbers" @paste="preventNonNumericPaste" @input="handleUserDeltaChange" />
                        <!-- :rules="[
                        (v) => !!v || 'User count required',
                        (v) => Number(v) > 0 || 'Must be greater than 0',
                      ]" -->
                        <v-card v-if="pricingBreakdown && formData.userDelta" variant="outlined" class="mt-3 pa-3">
                          <h4 class="text-subtitle-1 font-weight-medium mb-2">
                            License Cost Breakdown
                          </h4>

                          <v-divider class="mb-2" />

                          <v-row dense>
                            <v-col cols="6">Seats to Add</v-col>
                            <v-col cols="6" class="text-right font-weight-medium">
                              {{ pricingBreakdown.seats_to_add }}
                            </v-col>

                            <v-col cols="6">Price / User / Year</v-col>
                            <v-col cols="6" class="text-right font-weight-medium">
                              {{ pricingBreakdown.currency }}
                              {{ pricingBreakdown.price_per_user_per_year }}
                            </v-col>

                            <v-col cols="6">Days Remaining</v-col>
                            <v-col cols="6" class="text-right font-weight-medium">
                              {{ pricingBreakdown.days_remaining }} days
                            </v-col>

                            <v-col cols="6">Price / User / Day</v-col>
                            <v-col cols="6" class="text-right font-weight-medium">
                              {{ pricingBreakdown.currency }}
                              {{
                                pricingBreakdown.price_per_user_per_day.toFixed(4)
                              }}
                            </v-col>
                          </v-row>

                          <v-divider class="my-2" />

                          <v-row dense>
                            <v-col cols="6" class="font-weight-bold">
                              Estimated Total
                            </v-col>
                            <v-col cols="6" class="text-right font-weight-bold text-primary">
                              {{ pricingBreakdown.currency }}
                              {{ pricingBreakdown.estimated_total_cost }}
                            </v-col>
                          </v-row>

                          <v-alert type="info" variant="tonal" density="compact" class="mt-3">
                            {{ pricingBreakdown.message }}
                          </v-alert>
                        </v-card>
                      </v-col>
                      <v-col cols="6" v-if="['BOTH', 'MRR'].includes(formData.annualSubType)">
                        <v-text-field v-model="formData.mrrlicense" label="MRR license" variant="outlined"
                          density="compact" type="text" inputmode="numeric" maxlength="10" @keydown="allowOnlyNumbers"
                          @paste="preventNonNumericPaste" :readonly="formData.licenseType === 'ANNUAL' &&
                            formData.licenseType == formData.originalLicenseType &&
                            formData.annualSubType == formData.originalSubPlan
                            " @input="sanitizeNumber('mrrlicense')"
                          :rules="[(v) => !!v || 'MRR license Plan is required']" />
                      </v-col>
                      <v-col cols="6" v-if="
                        formData.originalLicenseType === 'ANNUAL' &&
                        ['BOTH', 'MRR'].includes(formData.annualSubType)
                      ">
                        <v-text-field v-model="formData.mrrlicenseData" label="No of MRR License  to Add "
                          variant="outlined" density="compact" type="text" inputmode="numeric" maxlength="6"
                          @keydown="allowOnlyNumbers" @paste="preventNonNumericPaste" />
                      </v-col>
                    </v-row>
                  </div>

                  <!-- ================= TRIAL ================= -->
                  <div v-if="formData.licenseType === 'TRIAL'">
                    <v-row dense>
                      <v-col cols="6">
                        <v-text-field v-model="formData.trialDays" label="Trial Days" variant="outlined"
                          density="compact" type="text" inputmode="numeric"
                          :readonly="formData.originalLicenseType === 'TRIAL'" maxlength="5" @keydown="allowOnlyNumbers"
                          @paste="preventNonNumericPaste" @input="sanitizeNumber('trialDays')" />
                      </v-col>
                      <v-col cols="6">
                        <v-text-field v-model="formData.noOfExtraTrailday" label="Add Trial Days" variant="outlined"
                          density="compact" type="text" inputmode="numeric" maxlength="5" @keydown="allowOnlyNumbers"
                          @paste="preventNonNumericPaste" @input="sanitizeNumber('noOfExtraTrailday')" />
                      </v-col>

                      <v-col cols="6">
                        <v-text-field v-model="formData.noOfUsers" label="License Users" variant="outlined"
                          density="compact" type="text" inputmode="numeric" maxlength="6" @keydown="allowOnlyNumbers"
                          @paste="preventNonNumericPaste" @input="sanitizeNumber('noOfUsers')" />
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <!-- ================= Primary Contact ================= -->
                <div class="mb-2">
                  <h3 class="text-h6 mb-3 primary--text">
                    Primary Contact (Owner / Super Admin)
                  </h3>

                  <v-row dense>
                    <v-col cols="6">
                      <v-text-field v-model="formData.fullName" label="Full Name*" variant="outlined" density="compact"
                        :rules="[(v) => !!v || 'Full Name is required']" />
                    </v-col>

                    <v-col cols="6">
                      <v-text-field v-model="formData.mobileNumber" label="Mobile Number" variant="outlined"
                        density="compact" maxlength="12" @input="formatPhoneNumber" :rules="[
                          (v) =>
                            !v ||
                            /^\d{3}-\d{3}-\d{4}$/.test(v) ||
                            'Mobile number must be 10 digits',
                        ]" />
                    </v-col>
                  </v-row>
                </div>
              </v-form>
            </v-card-text>

            <v-divider />

            <!-- ================= Actions ================= -->
            <v-card-actions class="pa-4">
              <v-spacer />
              <v-btn variant="text" color="grey" @click="handleClose">
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                variant="flat"
                :loading="loading"
                :disabled="
                  loading ||
                  (medicationCategoryList.length > 0 &&
                    !hasMedicationCategorySelected)
                "
                @click="handleSubmit"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-window-item>
          <v-window-item :value="1">
            <v-card-text class="pa-6" style="max-height: 65vh; overflow-y: auto">
              <div class="mb-6">
                <h3 class="text-h6 mb-3 primary--text">
                  Organization Settings
                </h3>

                <v-row dense>
                  <v-col cols="6">
                    <v-autocomplete v-model="formData.template_creation_level" label="Template Creation Required*"
                      variant="outlined" density="compact" :items="defaultItems" item-title="title" item-value="value"
                      :rules="[(v) => !!v || 'Template Creation is required']" />
                  </v-col>

                  <v-col cols="6">
                    <v-autocomplete v-model="formData.category_creation_level" label="Category Creation Required*"
                      variant="outlined" density="compact" :items="defaultItems" item-title="title" item-value="value"
                      :rules="[(v) => !!v || 'Category Creation is required']" />
                  </v-col>

                  <v-col cols="6">
                    <v-checkbox v-model="formData.should_consent_be_visible" label="Make Consent Visible"
                      color="primary" hide-details @keydown.enter.prevent="
                        handleCheckboxEnter('should_consent_be_visible')
                        "></v-checkbox>
                  </v-col>

                  <v-col cols="6">
                    <v-checkbox v-model="formData.medication_upload_tool_available" label="Medication Upload"
                      color="primary" hide-details @keydown.enter.prevent="
                        handleCheckboxEnter('medication_upload_tool_available')
                        "></v-checkbox>
                  </v-col>

                  <v-col cols="6">
                    <v-checkbox v-model="formData.should_summary_page_comments_be_visible" label="Facility Summary Page Comments"
                      color="primary" hide-details
                      @keydown.enter.prevent="handleCheckboxEnter('should_summary_page_comments_be_visible')" />
                  </v-col>

                  <v-col cols="6">
                    <v-checkbox v-model="formData.should_vault_be_visible" label="Vault Setting" color="primary"
                      hide-details @keydown.enter.prevent="handleCheckboxEnter('should_vault_be_visible')" />
                  </v-col>

                  <v-col cols="6">
                    <v-checkbox v-model="formData.should_invoice_be_visible" label="Invoice Upload" color="primary"
                      hide-details @keydown.enter.prevent="handleCheckboxEnter('should_invoice_be_visible')" />
                  </v-col>

                  <v-col cols="6">
                    <v-checkbox v-model="formData.internal_routing_available_bms"
                      label="Recommendation Internal Routing" color="primary" hide-details
                      @keydown.enter.prevent="handleCheckboxEnter('internal_routing_available_bms')" />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox v-model="formData.secondary_physician_routing_available"
                      label="Secondary Physician Routing" color="primary" hide-details
                      @keydown.enter.prevent="handleCheckboxEnter('secondary_physician_routing_available')" />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox v-model="formData.should_resident_labs_be_visible" label="Labs"
                      color="primary" hide-details
                      @keydown.enter.prevent="handleCheckboxEnter('should_resident_labs_be_visible')" />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox v-model="formData.should_gdr_be_visible" label="GDR Visibility"
                      color="primary" hide-details
                      @keydown.enter.prevent="handleCheckboxEnter('should_gdr_be_visible')" />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox v-model="formData.report_password_encryption_available"
                      label="Report Password Encryption" color="primary" hide-details
                      @keydown.enter.prevent="handleCheckboxEnter('report_password_encryption_available')" />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox v-model="formData.rcs_mhf_available"
                      label="RCF and MHF" color="primary" hide-details
                      @keydown.enter.prevent="handleCheckboxEnter('rcs_mhf_available')" />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox v-model="formData.merge_pharmacist_recommendation_setting_available"
                      label="Merge Pharmacist Recommendation" color="primary" hide-details
                      @keydown.enter.prevent="handleCheckboxEnter('merge_pharmacist_recommendation_setting_available')" />
                  </v-col>
                  <v-col cols="6">
                    <v-checkbox v-model="formData.templates_new_mode"
                      label="Templates New Mode" color="primary" hide-details
                      @keydown.enter.prevent="handleCheckboxEnter('templates_new_mode')" />
                  </v-col>


                  <v-col cols="12" v-if="sectionList.length">
                    <v-card variant="outlined" class="pa-4">
                      <div class="text-subtitle-1 font-weight-bold mb-4">
                        Organization Report Access
                      </div>

                      <v-row dense>
                        <v-col cols="12" v-if="sectionList.length > 2">
                          <v-checkbox :model-value="isAllSectionsSelected" label="Select All" color="primary"
                            density="compact" hide-details @update:modelValue="toggleAllSections" />
                        </v-col>

                        <v-col cols="12" v-for="item in sectionList" :key="item.section_value"
                          class="section-placement">
                          <div class="d-flex align-center ga-2">
                            <v-checkbox v-model="item.isenabled" :label="item.section_name" color="primary"
                              density="compact" hide-details class="flex-grow-0" />
                            <v-chip v-if="item.overridden_fields.length" size="x-small" color="primary"
                              variant="tonal">Custom</v-chip>
                            <v-btn v-if="item.overridden_fields.length" icon="mdi-restore" size="x-small" variant="text"
                              title="Reset to master" @click="resetSectionPlacement(item)" />
                          </div>
                          <div class="d-flex align-center flex-wrap ga-4 section-placement-fields">
                            <v-select :model-value="String(item.report_type || '').split('_')"
                              :items="sectionOptions(item, 'report_type', reportTypeOptions)" label="Report type" multiple
                              density="compact" variant="outlined" hide-details class="section-placement-select"
                              :disabled="isCumulativeSection(item)"
                              @update:model-value="(types) => types.length && setSectionField(item, 'report_type', joinReportTypes(types))">
                              <template #selection="{ index }">
                                <span v-if="index === 0" class="text-body-2 text-truncate" :title="reportTypeLabel(item)">
                                  {{ reportTypeLabel(item) }}
                                </span>
                              </template>
                            </v-select>
                            <div class="d-flex align-center flex-wrap">
                              <span class="text-caption text-medium-emphasis mr-2">Recommendation Type</span>
                              <v-checkbox v-for="type in sectionTypeOptions" :key="type" :label="type"
                                :model-value="sectionTypeList(item).includes(type)"
                                :disabled="isCumulativeSection(item) || (type !== 'MISC' && sectionTypeList(item).includes('MISC'))"
                                density="compact" hide-details color="primary" class="flex-grow-0 mr-2"
                                @update:model-value="(checked) => toggleSectionType(item, type, checked)" />
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-card variant="outlined" class="pa-4 h-100">
                      <div class="text-subtitle-1 font-weight-bold mb-4">
                        AI Chatbot Settings
                      </div>
 
                      <v-checkbox
                        v-model="formData.ai_chatbot_enabled"
                        label="Enable AI Chatbot"
                        color="primary"
                        hide-details
                        @keydown.enter.prevent="handleCheckboxEnter('ai_chatbot_enabled')"
                      />

                      <v-text-field
                        v-if="formData.ai_chatbot_enabled"
                        v-model="formData.ai_chatbot_name"
                        class="mt-4"
                        label="Chatbot Name*"
                        variant="outlined"
                        density="compact"
                        :rules="[
                          (v) =>
                            !formData.ai_chatbot_enabled ||
                            !!v ||
                            'Chatbot name is required',
                        ]"
                      />
                    </v-card>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-card variant="outlined" class="pa-4 h-100">
                      <div class="text-subtitle-1 font-weight-bold mb-4">
                        User Guide Settings
                      </div>

                      <v-checkbox
                        v-model="formData.user_guide_enabled"
                        label="Enable User Guide"
                        color="primary"
                        hide-details
                        @keydown.enter.prevent="handleCheckboxEnter('user_guide_enabled')"
                      />
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card variant="outlined" class="pa-4">
                      <div class="text-subtitle-1 font-weight-bold mb-4">
                        Exposed API Access
                      </div>

                      <v-checkbox
                        v-model="formData.exposed_api_access_enabled"
                        label="Enable Exposed API Access"
                        color="primary"
                        hide-details
                        @keydown.enter.prevent="
                          handleCheckboxEnter('exposed_api_access_enabled')
                        "
                        @update:modelValue="onExposedApiAccessToggle"
                      />

                      <v-checkbox
                        v-if="formData.exposed_api_access_enabled"
                        v-model="formData.show_api_call_cost"
                        label="Show API call cost"
                        color="primary"
                        hide-details
                        class="mt-2"
                        @keydown.enter.prevent="
                          handleCheckboxEnter('show_api_call_cost')
                        "
                      />

                      <div
                        v-if="formData.exposed_api_access_enabled"
                        class="mt-4"
                      >
                        <div class="text-body-2 text-medium-emphasis mb-4">
                          Update limits{{
                            formData.show_api_call_cost ? " and costs" : ""
                          }}
                          below.
                        </div>

                        <v-row
                          dense
                          v-for="(api, index) in formData.exposed_api_config"
                          :key="api.api_name"
                          class="mb-2"
                        >
                          <v-col
                            cols="12"
                            :md="formData.show_api_call_cost ? 4 : 6"
                          >
                            <v-text-field
                              :model-value="getExposedApiLabel(api.api_name)"
                              label="API Name"
                              variant="outlined"
                              density="compact"
                              readonly
                              hide-details
                            />
                          </v-col>
                          <v-col
                            :cols="formData.show_api_call_cost ? 6 : 12"
                            :md="formData.show_api_call_cost ? 4 : 6"
                          >
                            <v-text-field
                              v-model.number="
                                formData.exposed_api_config[index].limit
                              "
                              label="Limit*"
                              type="number"
                              min="0"
                              variant="outlined"
                              density="compact"
                              hide-details="auto"
                              :rules="[
                                (v) =>
                                  (v !== null &&
                                    v !== '' &&
                                    !Number.isNaN(Number(v))) ||
                                  'Limit is required',
                                (v) =>
                                  Number(v) >= 0 ||
                                  'Limit must be 0 or greater',
                              ]"
                            />
                          </v-col>
                          <v-col
                            v-if="formData.show_api_call_cost"
                            cols="6"
                            md="4"
                          >
                            <v-text-field
                              v-model.number="
                                formData.exposed_api_config[index].cost_per_call
                              "
                              label="Cost Per Call*"
                              type="number"
                              min="0"
                              step="0.01"
                              variant="outlined"
                              density="compact"
                              hide-details="auto"
                              :rules="[
                                (v) =>
                                  (v !== null &&
                                    v !== '' &&
                                    !Number.isNaN(Number(v))) ||
                                  'Cost is required',
                                (v) =>
                                  Number(v) >= 0 ||
                                  'Cost must be 0 or greater',
                              ]"
                            />
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card variant="outlined" class="pa-4">
                      <div class="text-subtitle-1 font-weight-bold mb-4">
                        Medication Category Settings
                      </div>

                      <v-row dense>
                        <v-col cols="12" v-if="medicationCategoryList.length > 1">
                          <v-checkbox :model-value="isAllMedicationCategoriesSelected" label="Select All"
                            color="primary" density="compact" hide-details
                            @update:modelValue="toggleAllMedicationCategories" />
                        </v-col>

                        <v-col cols="12" md="6" v-for="item in medicationCategoryList" :key="item.medication_category_id">
                          <v-checkbox v-model="item.isenabled" :label="formatMedicationCategoryName(item.medication_category_name)"
                            color="primary" density="compact" hide-details />
                        </v-col>

                        <v-col cols="12" v-if="!medicationCategoriesLoading && !medicationCategoryList.length">
                          <div class="text-body-2 text-medium-emphasis">
                            No medication categories available.
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>

            <v-divider />

            <v-card-actions class="pa-4">
              <v-spacer />
              <v-btn variant="text" color="grey" @click="handleClose">
                Cancel
              </v-btn>

              <v-btn
                color="primary"
                variant="flat"
                :loading="loading"
                :disabled="
                  loading ||
                  (medicationCategoryList.length > 0 &&
                    !hasMedicationCategorySelected)
                "
                @click="handleSubmit"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-window-item>
        </v-window>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import {
  edit_organization,
  manage_organization_license,
} from "@/graphql/mutations";
import { calculate_license_pricing } from "@/graphql/queries";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";
import countryList from "@/JsonFiles/CountryList.json";
import GetSectionsettings from "@/mixins/Organization/GetSectionsettings";
import GetMedicationCategories from "@/mixins/Medication/GetMedicationCategories";
import { formatMedicationCategoryName } from "@/utils/medicationCategoryLabel";

const EXPOSED_API_LABELS = {
  list_facilities: "List Facilities",
  list_facility_residents: "List Facility Residents",
  list_resident_recommendations: "List Resident Recommendations",
  list_resident_medications: "List Resident Medications",
  list_reports: "List Reports",
  list_all_recommendations: "List All Recommendations",
  list_facility_medications: "List Facility Medications",
};

const DEFAULT_EXPOSED_API_CONFIG = [
  { api_name: "list_facilities", limit: 5, cost_per_call: 0.02 },
  { api_name: "list_facility_residents", limit: 10, cost_per_call: 0.02 },
  {
    api_name: "list_resident_recommendations",
    limit: 13,
    cost_per_call: 0.02,
  },
  { api_name: "list_resident_medications", limit: 7, cost_per_call: 0.02 },
  { api_name: "list_reports", limit: 9, cost_per_call: 0.02 },
  { api_name: "list_all_recommendations", limit: 10, cost_per_call: 0.02 },
  { api_name: "list_facility_medications", limit: 10, cost_per_call: 0.02 },
];

function parseExposedApiConfig(raw) {
  if (!raw) return [];
  try {
    const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (Array.isArray(parsed)) return parsed;
    if (parsed && typeof parsed === "object") {
      return Object.keys(parsed).map((api_name) => ({
        api_name,
        limit: Number(parsed[api_name]?.limit) || 0,
        cost_per_call: Number(parsed[api_name]?.cost_per_call) || 0,
      }));
    }
    return [];
  } catch (error) {
    console.error("Error parsing exposed_api_config:", error);
    return [];
  }
}

function buildExposedApiConfig(existing = []) {
  const existingList = Array.isArray(existing)
    ? existing
    : parseExposedApiConfig(existing);
  return DEFAULT_EXPOSED_API_CONFIG.map((defaults) => {
    const match = existingList.find(
      (item) => item?.api_name === defaults.api_name
    );
    return {
      api_name: defaults.api_name,
      limit:
        match?.limit !== undefined && match?.limit !== null
          ? Number(match.limit)
          : defaults.limit,
      cost_per_call:
        match?.cost_per_call !== undefined && match?.cost_per_call !== null
          ? Number(match.cost_per_call)
          : defaults.cost_per_call,
    };
  });
}

export default {
  name: "EditOrganizationDialog",
  components: {
    SnackbarComponent,
  },
  mixins: [GetSectionsettings, GetMedicationCategories],
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    organization: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "updated"],
  data() {
    return {
      activeTab: 0,
      sectionList: [],
      reportTypeOptions: ["AFFILIATION", "CATEGORY", "FACILITY", "RESIDENT"],
      sectionTypeOptions: ["MRR", "IMRR", "ALF", "GHF", "MISC"],
      medicationCategoryList: [],
      medicationCategoriesLoading: false,
      valid: false,
      estimatedAmount: null,
      pricingBreakdown: null,
      loading: false,
      debounceTimer: null,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
      countries: countryList,
      formData: {
        organizationName: "",
        registeredAddress: "",
        organization_secondary_address: "",
        complianceLicense: "",
        fullName: "",
        email: "",
        country: "+1",
        mobileNumber: "",
        category_creation_level: "BOTH",
        template_creation_level: "BOTH",
        should_consent_be_visible: true,
        medication_upload_tool_available: false,
        should_summary_page_comments_be_visible: false,
        should_vault_be_visible: false,
        should_invoice_be_visible:false,
        should_resident_labs_be_visible: true,
        internal_routing_available_bms: false,
        secondary_physician_routing_available: false,
        should_gdr_be_visible: false,
        report_password_encryption_available: false,
        rcs_mhf_available: false,
        merge_pharmacist_recommendation_setting_available: false,
        templates_new_mode: false,
        exposed_api_access_enabled: false,
        exposed_api_config: buildExposedApiConfig(),
        show_api_call_cost: false,
        ai_chatbot_enabled: false,
        ai_chatbot_name: "",
        user_guide_enabled: false,
        originalLicenseType: "", // from backend
        licenseType: "",
        annualAmount: "",
        mrrlicense: "",
        trialDays: "",
        noOfUsers: "",
        userChangeType: "ADD_SEATS",
        userDelta: "",
        mrrlicenseData: "",
        originalSubPlan: "", // BOTH | ANNUAL | MRR
        annualSubType: "BOTH",
        noOfExtraTrailday: "",
        organization_settings: {},
      },
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => /.+@.+\..+/.test(v) || "Email must be valid",
      ],
      defaultItems: [
        { title: "Both", value: "BOTH" },
        { title: "User", value: "USER" },
        { title: "Organization", value: "ORGANIZATION" },
      ],
    };
  },
  computed: {
    isAllSectionsSelected() {
      return (
        this.sectionList.length > 0 &&
        this.sectionList.every((item) => item.isenabled)
      );
    },
    isAllMedicationCategoriesSelected() {
      if (!this.medicationCategoryList.length) return false;
      return this.medicationCategoryList.every((item) => item.isenabled);
    },
    hasMedicationCategorySelected() {
      return this.medicationCategoryList.some((item) => item.isenabled);
    },
    totalEstimateamount() {
      return (
        Number(this.estimatedAmount || 0) +
        Number(this.formData.annualAmount || 0)
      );
    },
    minUserCount() {
      return Number(this.organization?.licensed_user_count || 0);
    },
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    "formData.annualSubType"(val) {
      // 🚫 Restrict ONLY if original license was ANNUAL
      if (
        this.formData.originalLicenseType === "ANNUAL" &&
        this.formData.originalSubPlan === "BOTH" &&
        val !== "BOTH"
      ) {
        this.formData.annualSubType = "BOTH";
        return;
      }

      // Cleanup values
      if (val === "ANNUAL") {
        this.formData.mrrlicense = "";
        this.formData.mrrlicenseData = "";
      }

      if (val === "MRR") {
        this.formData.annualAmount = "";
        this.formData.noOfUsers = "";
        this.formData.userDelta = "";
      }
    },
    // "formData.userChangeType"() {
    //   this.formData.userDelta = "";
    //   this.estimatedAmount = null;
    // },
    modelValue(newVal) {
      if (newVal) {
        this.activeTab = 0;
        this.loadMedicationCategories();

        if (this.organization) {
          this.loadOrganizationData();
        }
      } else {
        this.resetForm();
      }
    },
    organization: {
      handler(newVal) {
        if (newVal && this.modelValue) {
          this.loadOrganizationData();
          this.getSectionListMethod(newVal.organization_id);
        }
      },
      immediate: true,
    },
  },
  methods: {
    formatMedicationCategoryName,
    async loadMedicationCategories() {
      this.medicationCategoriesLoading = true;
      try {
        await this.fetchMedicationCategories();
        this.buildMedicationCategoryList();
      } catch (error) {
        console.error("Error fetching medication categories:", error);
      } finally {
        this.medicationCategoriesLoading = false;
      }
    },
    getSavedMedicationCategorySettings() {
      if (!this.organization) {
        return [];
      }

      if (this.organization.medication_category_settings) {
        try {
          const parsed =
            typeof this.organization.medication_category_settings === "string"
              ? JSON.parse(this.organization.medication_category_settings)
              : this.organization.medication_category_settings;

          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          console.error("Error parsing medication_category_settings:", error);
        }
      }

      const selectedIds = Array.isArray(
        this.organization.selected_medication_category_ids
      )
        ? this.organization.selected_medication_category_ids
        : [];

      return selectedIds.map((categoryId) => ({
        medication_category_id: categoryId,
        isenabled: true,
      }));
    },
    buildMedicationCategoryList() {
      const savedSettings = this.getSavedMedicationCategorySettings();
      const hasSavedSettings = savedSettings.length > 0;
      const selectedIds = savedSettings
        .filter((item) => item.isenabled !== false)
        .map((item) => String(item.medication_category_id || item.category_id));

      this.medicationCategoryList = (this.medicationCategoriesList || [])
        .map((item) => {
          const medicationCategoryId =
            item.medication_category_id || item.category_id || "";
          const medicationCategoryName =
            item.medication_category_name || item.category_name || "";
          const saved = savedSettings.find(
            (setting) =>
              String(setting.medication_category_id || setting.category_id) ===
              String(medicationCategoryId)
          );
          const isPsychDefault =
            medicationCategoryName.toLowerCase().trim() === "psych";

          return {
            medication_category_id: medicationCategoryId,
            medication_category_name: medicationCategoryName,
            isenabled: saved
              ? saved.isenabled !== false
              : isPsychDefault
                ? true
                : hasSavedSettings
                  ? selectedIds.includes(String(medicationCategoryId))
                  : false,
          };
        })
        .filter(
          (item) => item.medication_category_id && item.medication_category_name
        );
    },
    toggleAllMedicationCategories(value) {
      this.medicationCategoryList.forEach((item) => {
        const isPsych =
          String(item.medication_category_name || "")
            .toLowerCase()
            .trim() === "psych";
        // Keep Psych selected by default when select-all is turned off
        item.isenabled = value || isPsych;
      });
    },
    sectionOptions(item, field, values) {
      const masterValues = field === "report_type"
        ? String(item.master_values?.report_type || "").split("_")
        : [item.master_values?.[field]];
      return values.map((value) => ({
        title: masterValues.includes(value) ? `${value} (default)` : value,
        value,
      }));
    },
    joinReportTypes(types) {
      return this.reportTypeOptions.filter((type) => types.includes(type)).join("_");
    },
    isCumulativeSection(item) {
      return String(item.master_values?.report_type || "").includes("CUMULATIVE");
    },
    setSectionField(item, field, value) {
      item[field] = value;
      item.overridden_fields = value === item.master_values?.[field]
        ? item.overridden_fields.filter((name) => name !== field)
        : [...new Set([...item.overridden_fields, field])];
    },
    sectionTypeList(item) {
      return String(item.section_types || "").split("_").filter(Boolean);
    },
    toggleSectionType(item, type, checked) {
      let types = this.sectionTypeList(item);
      if (type === "MISC") {
        types = checked ? ["MISC"] : ["MRR"];
      } else {
        types = checked ? [...types, type] : types.filter((name) => name !== type);
      }
      if (!types.length) return;
      this.setSectionField(item, "section_types", [...types].sort().join("_"));
    },
    reportTypeLabel(item) {
      return String(item.report_type || "")
        .split("_")
        .map((type) => type.charAt(0) + type.slice(1).toLowerCase())
        .join(", ");
    },
    resetSectionPlacement(item) {
      ["report_type", "section_types"].forEach((field) => {
        item[field] = item.master_values?.[field];
      });
      item.overridden_fields = [];
    },
    toggleAllSections(value) {
      this.sectionList.forEach((item) => {
        item.isenabled = value;
      });
    },
    handleCheckboxEnter(field) {
      this.formData[field] = !this.formData[field];
      if (field === "exposed_api_access_enabled") {
        this.onExposedApiAccessToggle(this.formData.exposed_api_access_enabled);
      }
    },
    getExposedApiLabel(apiName) {
      return EXPOSED_API_LABELS[apiName] || apiName;
    },
    onExposedApiAccessToggle(enabled) {
      if (enabled && !this.formData.exposed_api_config?.length) {
        this.formData.exposed_api_config = buildExposedApiConfig();
      }
      if (!enabled) {
        this.formData.show_api_call_cost = false;
      }
    },
    getBackendLicenseType() {
      if (this.formData.licenseType === "TRIAL") {
        return "TRIAL";
      }

      // licenseType === ANNUAL
      switch (this.formData.annualSubType) {
        case "ANNUAL":
          return "ANNUAL";
        case "MRR":
          return "MRR";
        case "BOTH":
        default:
          return "HYBRID";
      }
    },

    debouncedUserDeltaAction() {
      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.userDeltaCompleted();
      }, 500); // ⏱ 500ms debounce
    },
    handleUserDeltaChange() {
      // sanitize number
      this.formData.userDelta = this.formData.userDelta.replace(/\D/g, "");
      this.debouncedUserDeltaAction();
    },

    userDeltaCompleted() {
      // ✅ THIS runs only after typing stops
      console.log("User finished typing:", this.formData.userDelta);
      if (this.formData.userDelta) {
        this.getAmount();
      }
    },
    async getAmount() {
      try {
        const response = await client.graphql({
          query: calculate_license_pricing,
          variables: {
            input: {
              organization_id: this.organization.organization_id,
              seats_to_add: Number(this.formData.userDelta),
              annual_plan_price: Number(this.formData.annualAmount),
              base_user_count: Number(this.formData.noOfUsers),
              pricing_action:
                this.formData.originalLicenseType === "TRIAL" &&
                  this.formData.licenseType === "ANNUAL"
                  ? "CALCULATE_UPGRADE"
                  : "CALCULATE_ADD_SEATS",
            },
          },
        });

        let responseData = JSON.parse(response.data.calculate_license_pricing);
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.estimatedAmount = responseData.data.estimated_total_cost;
          this.pricingBreakdown = responseData.data;
          console.log(responseData);
        }
        // console.log(this.categoriesList)
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    },

    allowOnlyNumbers(e) {
      const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
      ];

      if (allowedKeys.includes(e.key)) return;

      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    },

    sanitizeNumber(modelKey) {
      this.formData[modelKey] = this.formData[modelKey].replace(/\D/g, "");
    },

    preventNonNumericPaste(e) {
      const pastedData = (e.clipboardData || window.clipboardData).getData(
        "text"
      );

      if (!/^\d+$/.test(pastedData)) {
        e.preventDefault();
      }
    },

    loadOrganizationData() {
      if (this.organization) {
        // console.log(this.organization);

        // Extract and format mobile number from contact_no
        let mobileNumber = "";
        if (this.organization.contact_no) {
          const contactNo = this.organization.contact_no;
          // Remove all non-numeric characters and format
          let digits = contactNo.replace(/\D/g, "");
          // If it starts with 1 (US country code), remove it
          if (digits.length === 11 && digits.startsWith("1")) {
            digits = digits.substring(1);
          }
          // Format as xxx-xxx-xxxx
          if (digits.length === 10) {
            mobileNumber =
              digits.slice(0, 3) +
              "-" +
              digits.slice(3, 6) +
              "-" +
              digits.slice(6);
          } else {
            mobileNumber = digits;
          }
        }

        const backendLicense = this.organization.license_type ?? "TRIAL";

        let licenseType = backendLicense === "TRIAL" ? "TRIAL" : "ANNUAL";
        let annualSubType = "BOTH";

        if (backendLicense === "ANNUAL") annualSubType = "ANNUAL";
        if (backendLicense === "MRR") annualSubType = "MRR";
        if (backendLicense === "HYBRID") annualSubType = "BOTH";

        this.formData = {
          organizationName: this.organization.organization_name || "",
          registeredAddress:
            this.organization.registeredAddress ||
            this.organization.organization_address ||
            "",
          organization_secondary_address:
            this.organization.organization_secondary_address?.trim()
              ? this.organization.organization_secondary_address
              : this.organization.organization_address || "",
          should_consent_be_visible: this.organization.should_consent_be_visible ?? true,
          medication_upload_tool_available: this.organization.medication_upload_tool_available ?? false,
          should_summary_page_comments_be_visible: this.organization.should_summary_page_comments_be_visible ?? false,
          should_vault_be_visible: this.organization.should_vault_be_visible ?? false,
          should_invoice_be_visible:this.organization.should_invoice_be_visible ?? false,
          should_resident_labs_be_visible:
            this.organization.should_resident_labs_be_visible ?? true,
          internal_routing_available_bms: this.organization.internal_routing_available_bms ?? false,
          secondary_physician_routing_available:
            this.organization.secondary_physician_routing_available === true,
          ai_chatbot_enabled: this.organization.ai_chatbot_enabled ?? false,
          ai_chatbot_name: this.organization.ai_chatbot_name || "",
          user_guide_enabled: this.organization.user_guide_enabled ?? false,
          should_gdr_be_visible: this.organization.should_gdr_be_visible ?? false,
          report_password_encryption_available:
            this.organization.report_password_encryption_available === true,
          rcs_mhf_available: this.organization.rcs_mhf_available === true,
          merge_pharmacist_recommendation_setting_available:
            this.organization.merge_pharmacist_recommendation_setting_available === true,
          templates_new_mode: this.organization.templates_new_mode === true,
          exposed_api_access_enabled:
            this.organization.exposed_api_access_enabled === true,
          exposed_api_config: buildExposedApiConfig(
            parseExposedApiConfig(this.organization.exposed_api_config)
          ),
          show_api_call_cost:
            this.organization.show_api_call_cost === true ||
            String(this.organization.show_api_call_cost)
              .trim()
              .toLowerCase() === "true",
          complianceLicense:
            this.organization.complianceLicense ||
            this.organization.licence_info ||
            "",
          fullName:
            this.organization.fullName || this.organization.owner_name || "",
          email:
            this.organization.email || this.organization.owner_email_id || "",
          country: "+1",
          mobileNumber,

          // 🔥 derived state
          originalLicenseType: licenseType,
          licenseType,
          originalSubPlan: annualSubType,
          annualSubType,

          annualAmount: this.organization.annual_plan_price || "",
          trialDays: this.organization.trial_days || "",
          mrrlicense: this.organization.mrr_license_count || "",
          noOfUsers: this.organization.licensed_user_count || "",

          category_creation_level:
            this.organization.category_creation_level || "BOTH",
          template_creation_level:
            this.organization.template_creation_level || "BOTH",
        };
        this.buildMedicationCategoryList();
        console.log(
          this.organization.license_type,
          annualSubType,
          this.formData.originalLicenseType
        );
      }
    },
    handleClose() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.medicationCategoryList = [];
      this.formData = {
        organizationName: "",
        registeredAddress: "",
        organization_secondary_address: "",
        complianceLicense: "",
        fullName: "",
        email: "",
        country: "+1",
        mobileNumber: "",
        should_consent_be_visible: false,
        medication_upload_tool_available: false,
        should_summary_page_comments_be_visible: false,
        should_vault_be_visible: false,
        should_invoice_be_visible:false,
        should_resident_labs_be_visible: true,
        should_gdr_be_visible: false,
        report_password_encryption_available: false,
        rcs_mhf_available: false,
        merge_pharmacist_recommendation_setting_available: false,
        templates_new_mode: false,
        exposed_api_access_enabled: false,
        exposed_api_config: buildExposedApiConfig(),
        show_api_call_cost: false,
        internal_routing_available_bms: false,
        secondary_physician_routing_available: false,
        ai_chatbot_enabled: false,
        ai_chatbot_name: "",
        user_guide_enabled: false,
        category_creation_level: "BOTH",
        template_creation_level: "BOTH",
        userChangeType: "ADD_SEATS",
        userDelta: "",
        mrrlicenseData: "",
        noOfExtraTrailday: "",
        organization_settings: {},
      };
    },

    formatPhoneNumber() {
      // Remove all non-numeric characters
      let value = this.formData.mobileNumber.replace(/\D/g, "");

      // Limit to 10 digits
      if (value.length > 10) {
        value = value.slice(0, 10);
      }

      // Format as xxx-xxx-xxxx
      if (value.length > 6) {
        value =
          value.slice(0, 3) + "-" + value.slice(3, 6) + "-" + value.slice(6);
      } else if (value.length > 3) {
        value = value.slice(0, 3) + "-" + value.slice(3);
      }

      this.formData.mobileNumber = value;
    },
    async handleSubmit() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;

      if (
        this.medicationCategoryList.length > 0 &&
        !this.hasMedicationCategorySelected
      ) {
        this.activeTab = 1;
        this.snackbar = {
          show: true,
          message: "Please select at least one medication category",
          color: "error",
        };
        return;
      }

      if (
        this.formData.ai_chatbot_enabled &&
        !this.formData.ai_chatbot_name?.trim()
      ) {
        this.activeTab = 1;
        this.snackbar = {
          show: true,
          message: "Chatbot name is required when AI Chatbot is enabled",
          color: "error",
        };
        return;
      }

      this.loading = true;

      try {
        /* 1️⃣ Update organization */
        const orgResponse = await client.graphql({
          query: edit_organization,
          variables: {
            input: {
              organization_id: this.organization.organization_id,
              organization_name: this.formData.organizationName,
              organization_address: this.formData.registeredAddress,
              licence_info: this.formData.complianceLicense,
              owner_name: this.formData.fullName,
              owner_email_id: this.formData.email,
              country_code: "+1",
              contact_no: this.formData.mobileNumber,
              should_consent_be_visible: this.formData.should_consent_be_visible || false,
              medication_upload_tool_available: this.formData.medication_upload_tool_available,
              should_summary_page_comments_be_visible: this.formData.should_summary_page_comments_be_visible,
              should_vault_be_visible:this.formData.should_vault_be_visible,
              should_invoice_be_visible: this.formData.should_invoice_be_visible,
              should_resident_labs_be_visible:
                this.formData.should_resident_labs_be_visible || false,
              internal_routing_available_bms: this.formData.internal_routing_available_bms,
              secondary_physician_routing_available:
                this.formData.secondary_physician_routing_available === true,
              should_gdr_be_visible: this.formData.should_gdr_be_visible || false,
              report_password_encryption_available:
                this.formData.report_password_encryption_available === true,
              rcs_mhf_available: this.formData.rcs_mhf_available === true,
              merge_pharmacist_recommendation_setting_available:
                this.formData.merge_pharmacist_recommendation_setting_available === true,
              templates_new_mode: this.formData.templates_new_mode === true,
              exposed_api_access_enabled:
                this.formData.exposed_api_access_enabled === true,
              exposed_api_config: JSON.stringify(
                this.formData.exposed_api_access_enabled
                  ? this.formData.exposed_api_config.map((api) => ({
                      api_name: api.api_name,
                      limit: Number(api.limit) || 0,
                      cost_per_call: Number(api.cost_per_call) || 0,
                    }))
                  : []
              ),
              show_api_call_cost: this.formData.show_api_call_cost === true,
              ai_chatbot_enabled: this.formData.ai_chatbot_enabled || false,
              ai_chatbot_name: this.formData.ai_chatbot_enabled
                ? this.formData.ai_chatbot_name?.trim() || ""
                : "",
              user_guide_enabled: this.formData.user_guide_enabled || false,
              license_type: this.getBackendLicenseType(),
              report_section_settings: JSON.stringify(
                this.sectionList.map((item) => ({
                  section_value: item.section_value,
                  section_types: item.section_types,
                  report_type: item.report_type,
                  section_name: item.section_name,
                  isenabled: item.isenabled,
                  overridden_fields: item.overridden_fields || [],
                })),
                null,
                2
              ),
              medication_category_settings: JSON.stringify(
                this.medicationCategoryList.map((item) => ({
                  medication_category_id: item.medication_category_id,
                  medication_category_name: item.medication_category_name,
                  isenabled: item.isenabled,
                })),
                null,
                2
              ),
              trial_days:
                this.formData.originalLicenseType === 'TRIAL' ? undefined :
                  this.formData.licenseType === "TRIAL"
                    ? Number(this.formData.trialDays)
                    : undefined,
              add_no_of_trial_days: this.formData.licenseType === "TRIAL" && this.formData.noOfExtraTrailday
                ? Number(this.formData.noOfExtraTrailday)
                : undefined,
              base_user_count: Number(this.formData.noOfUsers),
              category_creation_level: this.formData.category_creation_level,
              template_creation_level: this.formData.template_creation_level,
            },
          },
        });

        const orgResult = JSON.parse(orgResponse.data.edit_organization);
        if (orgResult.status !== "SUCCESS") {
          throw new Error(orgResult.status_message);
        }

        /* 2️⃣ Manage license */
        console.log(this.formData.licenseType, this.formData.originalLicenseType, 'this.formData.licenseType ')
        if (
          this.formData.originalLicenseType === "TRIAL" &&
          this.formData.licenseType === "ANNUAL"
        ) {

          await this.manageLicense();
        } else if (
          this.formData.licenseType === "ANNUAL" &&
          this.formData.originalSubPlan &&
          (this.formData.userDelta || this.formData.mrrlicenseData)
        ) {

          await this.manageLicense();

        }
        else if (this.formData.licenseType === "ANNUAL" &&
          this.formData.originalSubPlan) {
          await this.manageLicense();
        }
        else if (
          this.formData.licenseType === "ANNUAL" &&
          (this.formData.userDelta || this.formData.mrrlicenseData)
        ) {

          await this.manageLicense();
        }

        /* 3️⃣ Final success */
        this.snackbar = {
          show: true,
          message: "Organization & License updated successfully",
          color: "success",
        };

        this.$emit("updated", 0);
        this.handleClose();
        // console.log(
        //   "report_section_settings",
        //   JSON.stringify(
        //     this.sectionList.map((item) => ({
        //       recommendation_type: item.recommendation_type,
        //       section_value: item.section_value,
        //       facility_type: item.facility_type,
        //       report_type: item.report_type,
        //       section_name: item.section_name,
        //       isenabled: item.isenabled,
        //     })),
        //     null,
        //     2
        //   )
        // );

        // return;
      } catch (err) {
        this.snackbar = {
          show: true,
          message: err.message || "Something went wrong",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    },
    async manageLicense() {
      const input = {
        organization_id: this.organization.organization_id,

        // 🔥 ALWAYS tell backend final license type
        // license_type: this.getBackendLicenseType(),

        // license_action:
        //   this.formData.originalLicenseType === "TRIAL" &&
        //   this.formData.licenseType === "ANNUAL"
        //     ? "UPGRADE_TO_ANNUAL"
        //     : this.formData.annualSubType !== this.formData.originalSubPlan
        //     ? "CHANGE_SUB_PLAN"
        //     : this.formData.userDelta
        //     ? "ADD_SEATS"
        //     : "UPDATE_MRR_LICENSE",

        license_action:
          this.formData.originalLicenseType === "TRIAL" &&
            this.formData.licenseType === "ANNUAL"
            ? "UPGRADE_FROM_TRIAL"
            : this.formData.licenseType === "ANNUAL" &&
              this.formData.annualSubType != this.formData.originalSubPlan
              ? "SWITCH_LICENSE_TYPE"
              : this.formData.userDelta
                ? "ADD_SEATS"
                : "UPDATE_MRR_LICENSE",
        //
        plan_type:
          this.formData.licenseType === "ANNUAL"
            ? this.formData.annualSubType == "BOTH"
              ? "HYBRID"
              : this.formData.annualSubType
            : undefined,

        annual_plan_price: ["BOTH", "ANNUAL"].includes(
          this.formData.annualSubType
        )
          ? Number(this.formData.annualAmount)
          : undefined,

        base_user_count: Number(this.formData.noOfUsers),

        additional_seats: this.formData.userDelta
          ? Number(this.formData.userDelta)
          : undefined,

        add_mrr_license_count: ["BOTH", "MRR"].includes(
          this.formData.annualSubType
        )
          ? this.formData.mrrlicenseData
            ? Number(this.formData.mrrlicenseData)
            : undefined
          : undefined,
        mrr_license_count: this.formData.mrrlicense
          ? Number(this.formData.mrrlicense)
          : undefined
      };

      const response = await client.graphql({
        query: manage_organization_license,
        variables: { input },
      });

      return JSON.parse(response.data.manage_organization_license);
    },
  },
};
</script>

<style scoped>
.section-placement {
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  padding-bottom: 12px;
}

.section-placement-fields {
  padding-left: 40px;
}

.section-placement-select {
  flex: 0 0 260px;
}
</style>
